const ListOfPost = () => {
  if (window.matchMedia('(min-width: 1024px)').matches) {
    var elem = document.querySelector('.posts')
    var msnry = new Masonry(elem, {
      // options
      itemSelector: '.card-news',
      columnWidth: 200,
    })

    // element argument can be a selector string
    //   for an individual element
    var msnry = new Masonry('.posts', {
      // options
    })
  }
}

export default ListOfPost
